import { useEffect, useState } from 'react';
import {
  ButtonSecondary,
  ButtonSize,
  formatDate,
  IconClose,
  IconEdit,
  Textarea,
} from '@ui/src';
import { CommentTypes } from './types';
import cn from './styles.module.css';

const Comment = ({
  comment,
  editAvailable,
  updateIssueCommentAction,
  updateIssueCommentInProgress,
  updateIssueCommentIsSuccess,
}: CommentTypes) => {
  const [isEdit, setIsEdit] = useState(false);
  const [commentText, setCommentText] = useState('');

  useEffect(() => {
    if (comment) {
      setCommentText(comment.content);
    }
  }, [comment]);

  useEffect(() => {
    if (updateIssueCommentIsSuccess) {
      setIsEdit(false);
    }
  }, [updateIssueCommentIsSuccess]);

  let content;

  if (isEdit) {
    content = (
      <div>
        <Textarea
          name="commentText"
          value={commentText}
          onChange={(e) => setCommentText(e.target.value)}
          placeholder="Enter comment"
          disabled={updateIssueCommentInProgress}
          className={cn.commentTextarea}
        />
        <div className={cn.saveButtonWrapper}>
          <ButtonSecondary
            className="button-white"
            size={ButtonSize.SMALL}
            text={updateIssueCommentInProgress ? 'Loading...' : 'Save'}
            disabled={updateIssueCommentInProgress}
            onClick={() =>
              updateIssueCommentAction &&
              updateIssueCommentAction({
                commentId: comment?.id as string,
                text: commentText,
              })
            }
          />
        </div>
      </div>
    );
  } else {
    content = <div className={cn.issueCommentText}>{commentText}</div>;
  }

  return (
    <div className={cn.issueComment}>
      <div className={cn.issueCommentTop}>
        <div className={cn.issueCommentTopLeft}>
          <div>{`${comment?.user?.profile?.firstName} ${comment?.user?.profile?.lastName}`}</div>
          {comment?.createdAt && (
            <div>{formatDate(comment.createdAt, true)}</div>
          )}
        </div>
        <div className={cn.issueCommentTopRight}>
          {editAvailable && (
            <button
              type="button"
              className={cn.issueCommentEditButton}
              aria-label="Edit comment"
              onClick={() => {
                if (!isEdit) {
                  setIsEdit(true);
                } else {
                  setIsEdit(false);
                  setCommentText(comment?.content as string);
                }
              }}
              disabled={updateIssueCommentInProgress}
            >
              {isEdit ? (
                <IconClose width={16} height={16} />
              ) : (
                <IconEdit width={16} height={16} />
              )}
            </button>
          )}
        </div>
      </div>
      {content}
    </div>
  );
};

export default Comment;
